import { render, staticRenderFns } from "./CustomFieldOverTipsDialog.vue?vue&type=template&id=f841251c&scoped=true"
import script from "./CustomFieldOverTipsDialog.vue?vue&type=script&lang=js"
export * from "./CustomFieldOverTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldOverTipsDialog.vue?vue&type=style&index=0&id=f841251c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f841251c",
  null
  
)

export default component.exports